import ReturnForm from "@/components/ReturnForm";

export default function SaleReturn() {
  return <ReturnForm mode="sale" />;
}
